import { faBan, faCheck, faEdit, faFilePdf, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useState } from 'react';
import { format } from 'date-fns';
import { FieldArray } from 'formik';
import { Button, Col, Container, Form, FormLabel, InputGroup, Modal, Row, Spinner, Table } from 'react-bootstrap';
import Crud from '../../../components/Crud';
import Input from '../../../components/Input';
import Dropzone from '../../../components/Dropzone';
import config from '../../../config';
import schema from './schema';
import Axios from "axios";

const formatValorBR = (valor) => {
  if (valor === null || valor === undefined || valor === '') return '';

  const numero = Number(valor);

  if (Number.isNaN(numero)) return valor;

  return numero.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const columns = [
  { header: 'Exercício', property: 'exercicio', filter: true },
  { header: 'Autoria da Emenda', property: 'autoria', filter: true },
  { header: 'Tipo da Emenda', property: 'emendaParlamentarTipo.nome', filter: true },
  { header: 'Município', property: 'municipio', filter: true },
  { header: 'Órgão Concedente', property: 'orgaoConcedente', filter: true },
  { header: 'Entidade Beneficiada', property: 'funcao.nome', filter: true },
  { header: 'CPF/CNPJ', property: 'documento', filter: true },
  { header: 'Prestação de Contas', property: 'prestacaoDeContas', filter: true },
  { header: 'Intercorrências', property: 'intercorrencias', filter: true },
  { header: 'Data da Emenda', property: 'dataDaEmenda', filter: true, format: (data) => data ? format(new Date(data), 'dd/MM/yyyy') : '' },
  { header: 'Estágio da Emenda', property: 'estagioEmenda', filter: true },
  { header: 'Estágio do Processo Licitatório', property: 'estagioProcessoLicitatorio', filter: true },
  { header: 'Estágio do Controle Orçamentário e Financeiro', property: 'estagioControleOrcamentarioFinanceiro', filter: true },
  { header: 'Valor Previsto', property: 'valorPrevisto', filter: true, format: formatValorBR },
  { header: 'Valor Realizado', property: 'valorRealizado', filter: true, format: formatValorBR },
  { header: 'Conta para depósito', property: 'contaParaDeposito', filter: true },
  { header: 'Número proposta', property: 'numeroProposta', filter: true },
  { header: 'Número da emenda', property: 'numeroEmenda', filter: true },
  { header: 'Detalhamento do objeto', property: 'detalhamentoObjeto', filter: true },
  { header: 'Detalhamento das ações', property: 'detalhamentoAcoes', filter: true },
  { header: 'Detalhamento financeiro', property: 'detalhamentoFinanceiro', filter: true },
];

const handleUpload = (handleChange, index) => {
  return (response) => {
    const caminho = response.data.data;

    if (!caminho) {
      return;
    }

    handleChange({
      target: {
        id: `emendaParlamentarArquivos.${index}.caminho`,
        value: caminho,
      },
    });
  };
};

export default function EmendaParlamentarPrivatePage() {
  const [arquivosEmendaParlamentar, setArquivosEmendaParlamentar] = useState([]);
  const [visivel, setVisivel] = useState(false);

  const [isDeleting, setIsDeleting] = useState(false);
  const [isEditing, setIsEditing] = useState(true);
  const [idArquivoDelete, setIdArquivoDelete] = useState();
  const [idArquivoEditar, setIdArquivoEditar] = useState();
  const [novoNomeArquivo, setNovoNomeArquivo] = useState('');
  const [nomeArquivoPasta, setNomeArquivoPasta] = useState('');

  const hide = () => {
    setArquivosEmendaParlamentar([]);
    setVisivel(false);
  };

  const show = async (licitacao) => {
    getArquivos(licitacao.id);
    setVisivel(true);
  };

  const getArquivos = async (emendaParlamentarId) => {
    const data = await Axios.get(`${config.api_path}/v1/transparencia/emenda-parlamentar/arquivo/listar/${emendaParlamentarId}`);
    setArquivosEmendaParlamentar(data.data.data);
    setIdArquivoDelete(null);
    setIdArquivoEditar(null);
    setIsDeleting(false);
    setIsEditing(false);
  };

  const handleDeleteArquivo = async (arquivoId, emendaParlamentarId) => {
    setIsDeleting(true);
    await Axios.delete(`${config.api_path}/v1/transparencia/emenda-parlamentar/arquivo/deletar/${arquivoId}`).then((res) =>
      console.log(res)
    );
    getArquivos(emendaParlamentarId);
  };

  const handleUpdateArquivo = async (arquivoId, emendaParlamentarId) => {
    setIsEditing(true);
    await Axios.put(`${config.api_path}/v1/transparencia/emenda-parlamentar/arquivo/editar/${arquivoId}`, {
      nome: novoNomeArquivo,
      emendaParlamentarArquivoPasta: nomeArquivoPasta,
    }).then((res) => console.log(res));
    getArquivos(emendaParlamentarId);
  };

  return (
    <Crud
      header='Emenda Parlamentar'
      columns={columns}
      path={`${config.api_path}/v1/transparencia/emenda-parlamentar`}
      rows={20}
      schema={schema}
      buttonBar={({ selected }) => (
        <>
          <div>
            <Modal show={visivel} onHide={hide} size='xl'>
              <Modal.Header style={{ backgroundColor: '#074E80', height: '50px' }} closeButton />
              <Modal.Body>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>
                        <FormLabel>Arquivos</FormLabel>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <Container className='p-0 mb-4'>
                          {arquivosEmendaParlamentar
                            ? arquivosEmendaParlamentar.map((arquivo) => (
                                <Container>
                                  <Row className='mb-2'>
                                    <td className='col'>
                                      <Col>
                                        <FormLabel>
                                          <i className='mr-2'>
                                            <FontAwesomeIcon icon={faFilePdf} />{' '}
                                          </i>
                                          {arquivo.nome}
                                        </FormLabel>
                                      </Col>
                                      {isEditing ? (
                                        <Row
                                          className='mb-4 mt-2'
                                          hidden={idArquivoEditar === arquivo.id ? false : true}
                                        >
                                          <Col>
                                            <Spinner animation='border' />
                                          </Col>
                                        </Row>
                                      ) : (
                                        <Col hidden={idArquivoEditar === arquivo.id ? false : true}>
                                          <Form.Group>
                                            <FormLabel>Nome</FormLabel>
                                            <InputGroup>
                                              <Input.Text
                                                id='nome'
                                                value={arquivo.nome}
                                                onChange={(e) => setNovoNomeArquivo(e.target.value)}
                                              />
                                            </InputGroup>
                                          </Form.Group>

                                          <Form.Group>
                                            <FormLabel>Seção</FormLabel>
                                            <Input.AsyncSelect
                                              id='emendaParlamentarArquivoPasta'
                                              value={arquivo.emendaParlamentarArquivoPasta}
                                              onChange={(e) => setNomeArquivoPasta(e.target.value)}
                                              path={`${config.api_path}/v1/transparencia/emenda-parlamentar-arquivo-pasta`}
                                              label={'${nome}'}
                                              rowKey='id'
                                              nullable
                                              placeholder='Selecione uma seção'
                                              />
                                          </Form.Group>

                                          <Button
                                            onClick={() => handleUpdateArquivo(arquivo.id, arquivo.emendaParlamentar.id)}
                                          >
                                            Editar arquivo
                                          </Button>
                                        </Col>
                                      )}
                                    </td>
                                    <td>
                                      <Row
                                        className='justify-content-center align-items-center'
                                        hidden={idArquivoDelete === arquivo.id ? true : false}
                                      >
                                        <Col>
                                          <Button size='lg' onClick={() => setIdArquivoDelete(arquivo.id)}>
                                            <FontAwesomeIcon icon={faMinus} />
                                          </Button>
                                        </Col>
                                        <Col>
                                          <Button
                                            size='lg'
                                            onClick={() => {
                                              setNovoNomeArquivo('');
                                              setIdArquivoEditar(arquivo.id);
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faEdit} />
                                          </Button>
                                        </Col>
                                      </Row>
                                      {isDeleting ? (
                                        <Row
                                          className='mb-4 mt-2'
                                          hidden={idArquivoDelete === arquivo.id ? false : true}
                                        >
                                          <Col>
                                            <Spinner animation='border' />
                                          </Col>
                                        </Row>
                                      ) : (
                                        <Row
                                          className='justify-content-center align-items-center'
                                          hidden={idArquivoDelete === arquivo.id ? false : true}
                                        >
                                          <Col>
                                            <Button
                                              size='lg'
                                              onClick={() => handleDeleteArquivo(arquivo.id, arquivo.emendaParlamentar.id)}
                                            >
                                              <FontAwesomeIcon icon={faCheck} />
                                            </Button>
                                          </Col>
                                          <Col>
                                            <Button size='lg' onClick={() => setIdArquivoDelete(null)}>
                                              <FontAwesomeIcon icon={faBan} />
                                            </Button>
                                          </Col>
                                        </Row>
                                      )}
                                    </td>
                                  </Row>
                                </Container>
                              ))
                            : ''}
                        </Container>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Modal.Body>
            </Modal>
          </div>

          <Row>
            <Col>
              <Button
                onClick={() => {
                  if (selected) {
                    show(selected);
                  }
                }}
                disabled={!selected}
              >
                Alterar arquivos
              </Button>
            </Col>
          </Row>
        </>
      )}
      form={({ handleChange, values, errors }) => (
        <Fragment>
          <Row>
            <Col md={2}>
              <Form.Group>
                <FormLabel>Exercício</FormLabel>
                <InputGroup>
                  <Input.Text
                    type='number'
                    id='exercicio'
                    onChange={handleChange}
                    value={values.exercicio}
                    isInvalid={errors.exercicio}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.exercicio}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <FormLabel>Autor da Emenda</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='autoria'
                    onChange={handleChange}
                    value={values.autoria}
                    isInvalid={errors.autoria}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.autoria}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <FormLabel>Tipo da Emenda</FormLabel>
                <Input.AsyncSelect
                  id='emendaParlamentarTipo'
                  value={values.emendaParlamentarTipo}
                  onChange={handleChange}
                  isInvalid={errors.emendaParlamentarTipo}
                  path={`${config.api_path}/v1/transparencia/emenda-parlamentar-tipo`}
                  label={'${nome}'}
                  rowKey='id'
                  nullable
                  placeholder='Selecione um tipo'
                />
                <Form.Control.Feedback type='invalid'>{errors.emendaParlamentarTipo}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <FormLabel>Município</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='municipio'
                    onChange={handleChange}
                    value={values.municipio}
                    isInvalid={errors.municipio}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.municipio}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group>
                <FormLabel>Órgão Concedente</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='orgaoConcedente'
                    onChange={handleChange}
                    value={values.orgaoConcedente}
                    isInvalid={errors.orgaoConcedente}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.orgaoConcedente}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <FormLabel>Entidade Beneficiada</FormLabel>
                <Input.AsyncSelect
                  id='funcao'
                  value={values.funcao}
                  onChange={handleChange}
                  isInvalid={errors.funcao}
                  path={`${config.api_path}/v1/siorconp/funcao`}
                  label={'${nome}'}
                  rowKey='id'
                  nullable
                  placeholder='Selecione uma Entidade Beneficiada'
                />
                <Form.Control.Feedback type='invalid'>{errors.funcao}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <FormLabel>CPF/CNPJ</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='documento'
                    onChange={handleChange}
                    value={values.documento}
                    isInvalid={errors.documento}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.documento}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={2}>
              <Form.Group>
                <FormLabel>Valor Previsto</FormLabel>
                <InputGroup>
                  <Input.Text
                    type='number'
                    id='valorPrevisto'
                    onChange={handleChange}
                    value={values.valorPrevisto}
                    isInvalid={errors.valorPrevisto}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.valorPrevisto}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <FormLabel>Valor Aprovado</FormLabel>
                <InputGroup>
                  <Input.Text
                    type='number'
                    id='valorRealizado'
                    onChange={handleChange}
                    value={values.valorRealizado}
                    isInvalid={errors.valorRealizado}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.valorRealizado}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={8}>
              <Form.Group>
                <FormLabel>Conta para depósito</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='contaParaDeposito'
                    onChange={handleChange}
                    value={values.contaParaDeposito}
                    isInvalid={errors.contaParaDeposito}
                    placeholder="banco, agência e conta corrente"
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.contaParaDeposito}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group>
                <FormLabel>Código Único Segregado</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='codigoUnicoSegregado'
                    onChange={handleChange}
                    value={values.codigoUnicoSegregado}
                    isInvalid={errors.codigoUnicoSegregado}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.codigoUnicoSegregado}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <FormLabel>Número da Proposta</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='numeroProposta'
                    onChange={handleChange}
                    value={values.numeroProposta}
                    isInvalid={errors.numeroProposta}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.numeroProposta}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <FormLabel>Número da Emenda</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='numeroEmenda'
                    onChange={handleChange}
                    value={values.numeroEmenda}
                    isInvalid={errors.numeroEmenda}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.numeroEmenda}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group>
                <FormLabel>Painel de Emenda Governo Federal (Consulta Link)</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='painelEmendaGovFederal'
                    onChange={handleChange}
                    value={values.painelEmendaGovFederal}
                    isInvalid={errors.painelEmendaGovFederal}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.painelEmendaGovFederal}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <FormLabel>Painel de Emenda Governo Estadual (Consulta Link)</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='painelEmendaGovEstadual'
                    onChange={handleChange}
                    value={values.painelEmendaGovEstadual}
                    isInvalid={errors.painelEmendaGovEstadual}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.painelEmendaGovEstadual}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group>
                <FormLabel>Data da Solicitação da Emenda</FormLabel>
                <InputGroup>
                  <Input.Date
                    id='dataSolicitacaoEmenda'
                    onChange={handleChange}
                    value={values.dataSolicitacaoEmenda}
                    isInvalid={errors.dataSolicitacaoEmenda}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.dataSolicitacaoEmenda}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <FormLabel>Data da Aprovação da Emenda</FormLabel>
                <InputGroup>
                  <Input.Date
                    id='dataDaEmenda'
                    onChange={handleChange}
                    value={values.dataDaEmenda}
                    isInvalid={errors.dataDaEmenda}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.dataDaEmenda}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <FormLabel>Data da Liberação da Emenda</FormLabel>
                <InputGroup>
                  <Input.Date
                    id='dataLiberacaoEmenda'
                    onChange={handleChange}
                    value={values.dataLiberacaoEmenda}
                    isInvalid={errors.dataLiberacaoEmenda}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.dataLiberacaoEmenda}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Form.Group>
                <FormLabel>Emenda Data do Início</FormLabel>
                <InputGroup>
                  <Input.Date
                    id='dataInicioEmenda'
                    onChange={handleChange}
                    value={values.dataInicioEmenda}
                    isInvalid={errors.dataInicioEmenda}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.dataInicioEmenda}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <FormLabel>Data do Final</FormLabel>
                <InputGroup>
                  <Input.Date
                    id='dataFinalEmenda'
                    onChange={handleChange}
                    value={values.dataFinalEmenda}
                    isInvalid={errors.dataFinalEmenda}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.dataFinalEmenda}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <FormLabel>Termo Aditivo Data Inicial</FormLabel>
                <InputGroup>
                  <Input.Date
                    id='dataInicioTermoAditivo'
                    onChange={handleChange}
                    value={values.dataInicioTermoAditivo}
                    isInvalid={errors.dataInicioTermoAditivo}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.dataInicioTermoAditivo}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <FormLabel>Data Final</FormLabel>
                <InputGroup>
                  <Input.Date
                    id='dataFinalTermoAditivo'
                    onChange={handleChange}
                    value={values.dataFinalTermoAditivo}
                    isInvalid={errors.dataFinalTermoAditivo}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.dataFinalTermoAditivo}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group>
                <FormLabel>Fonte de Recurso</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='fonteRecurso'
                    onChange={handleChange}
                    value={values.fonteRecurso}
                    isInvalid={errors.fonteRecurso}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.fonteRecurso}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <FormLabel>Código da Receita</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='codigoReceita'
                    onChange={handleChange}
                    value={values.codigoReceita}
                    isInvalid={errors.codigoReceita}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.codigoReceita}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Atos Normativos que Aprovou a Emenda</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='atosNormativos' value={values.atosNormativos} onChange={handleChange} isInvalid={errors.atosNormativos} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.atosNormativos}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Detalhamento do Objeto Gasto Aprovado na Emenda</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='detalhamentoObjeto' value={values.detalhamentoObjeto} onChange={handleChange} isInvalid={errors.detalhamentoObjeto} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.detalhamentoObjeto}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Detalhamento das Ações – Plano de Trabalho-Cronograma Físico Financeiro-Prazo de Execução-Metas a serem alcançadas</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='detalhamentoAcoes' value={values.detalhamentoAcoes} onChange={handleChange} isInvalid={errors.detalhamentoAcoes} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.detalhamentoAcoes}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Estágio do Demonstrativo Orçamentário e Financeiro Tempestivo – Receita- Empenho-Liquidação-Pagamento-Anulação Link Consulta</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='detalhamentoFinanceiro' value={values.detalhamentoFinanceiro} onChange={handleChange} isInvalid={errors.detalhamentoFinanceiro} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.detalhamentoFinanceiro}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Estágio da Emenda</FormLabel>
                <InputGroup>
                  <Input.Text
                  as='textarea'
                  id='estagioEmenda'
                  value={values.estagioEmenda}
                  onChange={handleChange}
                  isInvalid={errors.estagioEmenda}
                  placeholder='Em análise, impedimento técnico, parcialmente executada, totalmente executada ou não iniciada'
                />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.estagioEmenda}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Estágio do Processo Licitatório</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='estagioProcessoLicitatorio' value={values.estagioProcessoLicitatorio} onChange={handleChange} isInvalid={errors.estagioProcessoLicitatorio} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.estagioProcessoLicitatorio}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Estágio do Controle Orçamentário e Financeiro</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='estagioControleOrcamentarioFinanceiro' value={values.estagioControleOrcamentarioFinanceiro} onChange={handleChange} isInvalid={errors.estagioControleOrcamentarioFinanceiro} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.estagioControleOrcamentarioFinanceiro}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Intercorrências</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='intercorrencias' value={values.intercorrencias} onChange={handleChange} isInvalid={errors.intercorrencias} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.intercorrencias}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Prestação de Contas da Execução do Objeto da Emenda</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='prestacaoDeContas' value={values.prestacaoDeContas} onChange={handleChange} isInvalid={errors.prestacaoDeContas} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.prestacaoDeContas}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Instrumento Jurídico - Convênio-Contratos-Repasses-Termos Aditivos-Apostilamento-Termo de Fomento-Outros</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='instrumentoJuridico' value={values.instrumentoJuridico} onChange={handleChange} isInvalid={errors.instrumentoJuridico} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.instrumentoJuridico}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Informações Complementares-Normatização</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='informacoesComplementares' value={values.informacoesComplementares} onChange={handleChange} isInvalid={errors.informacoesComplementares} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.informacoesComplementares}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <FormLabel>Anotações Complementares - Resolução Nº 302/2025-</FormLabel>
                <InputGroup>
                  <Input.Text as='textarea' id='anotacoesComplementares' value={values.anotacoesComplementares} onChange={handleChange} isInvalid={errors.anotacoesComplementares} />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.anotacoesComplementares}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={10}>
              <Form.Group>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>
                        <FormLabel>Arquivos</FormLabel>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <FieldArray
                          name='emendaParlamentarArquivos'
                          render={(arrayHelper) => (
                            <Container className='p-0'>
                              <Row className='mb-4'>
                                <Col>
                                  <Button type='button' onClick={() => arrayHelper.push({})}>
                                    <FontAwesomeIcon icon={faPlus} />
                                  </Button>
                                </Col>
                              </Row>

                              {values.emendaParlamentarArquivos &&
                                values.emendaParlamentarArquivos.map((arquivo, index) => (
                                  <div key={index}>
                                    <Container>
                                      <Row className='mb-4'>
                                        <td className='col'>
                                          <Col className='mb-4'>
                                            <Form.Group>
                                              <FormLabel>Nome do arquivo</FormLabel>
                                              <Input.Text
                                                id={`emendaParlamentarArquivos.${index}.nome`}
                                                value={values.emendaParlamentarArquivos[index].nome}
                                                onChange={handleChange}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col className='mb-4'>
                                          <Form.Group>
                                            <FormLabel>Seção</FormLabel>
                                            <Input.AsyncSelect
                                              id={`emendaParlamentarArquivos.${index}.emendaParlamentarArquivoPasta`}
                                              value={values.emendaParlamentarArquivos[index].emendaParlamentarArquivoPasta}
                                              onChange={handleChange}
                                              path={`${config.api_path}/v1/transparencia/emenda-parlamentar-arquivo-pasta`}
                                              label={'${nome}'}
                                              rowKey='id'
                                              nullable
                                              placeholder='Selecione uma seção'
                                            />
                                          </Form.Group>
                                          </Col>
                                        </td>

                                        <td className='col'>
                                          <Col>
                                            {arquivo.caminho ? (
                                              arquivo.caminho
                                            ) : (
                                              <Dropzone
                                                id={`emendaParlamentarArquivos.${index}.upload`}
                                                route={`${config.api_path}/v1/transparencia/emenda-parlamentar/arquivo/upload`}
                                                accept='.pdf'
                                                onUpload={handleUpload(handleChange, index)}
                                              />
                                            )}
                                          </Col>
                                        </td>

                                        <td style={{ display: 'flex' }}>
                                          <Row className='justify-content-center align-items-center'>
                                            <Col>
                                              <Button type='button' size='lg' onClick={() => arrayHelper.remove(index)}>
                                                <FontAwesomeIcon icon={faMinus} />
                                              </Button>
                                            </Col>
                                          </Row>
                                        </td>
                                      </Row>
                                    </Container>
                                  </div>
                                ))}
                            </Container>
                          )}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Form.Group>
            </Col>
          </Row>
        </Fragment>
      )}
    ></Crud>
  );
}
